<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="$route.path == '/Report/Movement'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form autocomplete="off" class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-xs-4">
                <div class="form-group">
                  <label>BARCODE :</label>
                  <input v-model="reMmBarcode" type="text" class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)" />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-xs-4">
                <div class="form-group">
                  <label>รหัสทรัพย์สิน(เบียร์สด) :</label>
                  <treeselect v-model="reMmDepartmentMaterialCode" :multiple="true"
                    :load-options="LoadreMmDepartmentMaterialCodeOptions" :async="true" v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา" placeholder="กรุณาเลือก" :cacheOptions="false" />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-xs-4"></div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-xs-4">
                <div class="form-group ">
                  <label class="label">วันที่(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input type="text" class="form-control" placeholder="(วว/ดด/ปปปป)" id="reMmTransactionDateStart"
                      name="reMmTransactionDateStart" ref="reMmTransactionDateStart" :disabled="IsShowDatePicker" readonly/>
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-xs-4">
                <div class="form-group">
                  <label class="label">วันที่(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input type="text" class="form-control" placeholder="(วว/ดด/ปปปป)" id="reMmTransactionDateEnd"
                      name="reMmTransactionDateEnd" ref="reMmTransactionDateEnd" :disabled="IsShowDatePicker" readonly/>
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button type="reset" class="btn btn-secondary" @click="formReset">
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="exportMovement" type="submit">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="movementTable" style="width:100%">
                <thead>
                  <tr>
                    <th class="all text-right" colspan="16">
                      ข้อมูล ณ วันที่ {{ reMmDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">BARCODE</th>
                    <th class="all text-center">รหัสทรัพย์สิน(เบียร์สด)</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">เลขที่ใบงาน</th>
                    <th class="all text-center">ประเภทใบงาน</th>
                    <th class="all text-center">สถานะ</th>
                    <th class="all text-center">ต้นทาง</th>
                    <th class="all text-center">ปลายทาง</th>
                    <th class="all text-center">ขนส่ง</th>
                    <th class="all text-center">ทะเบียนขนส่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let ActionsOpenJob = Vue.extend({
  template: `
    <a href="#" @click.prevent="openJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายละเอียดเอกสารใบงานต้นทาง">
      <i class="la la-external-link"></i>
    </a>
  `,
  methods: {
    openJob: function () {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      // Issue #35 (CR-Job-Stock 2026-06-03): WriteOff jobs ต้องเปิดหน้า View
      // ของ WriteOff โดยตรง (หน้า Edit generic ไม่รองรับ JobType นี้) — Job type
      // อื่นๆ ใช้ logic เดิม
      var rowData = this.data;
      axios
        .post("/Api/Jobs/GetJobId", {
          JobNumber: rowData.jobNumber,
        })
        .then(function (response) {
          if (response.status == 200) {
            var url = (rowData.jobTypeCode === "JOB_TYPE_WRITE_OFF_STOCK")
              ? "/Jobs/WriteOffStock/View/" + response.data
              : "/Jobs/Edit/" + response.data;
            window.open(url, "_blank");
          } else {
            // always executed
            KTApp.unblockPage();
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
          }
        })
        .catch(function (error) {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function () {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function () {
    var self = this;

    return {
      reOrderBy: null,
      reMmDateReq: null,
      reMmIsInitial: true,
      reMmBarcode: null,
      reMmDepartmentMaterialCode: [],
      reMmNFCCode: [],
      reMmTransactionDateStart: null,
      reMmTransactionDateEnd: null,

      reMmBarcodeOptions: {
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function (params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function (data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function (params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reMmDepartmentMaterialCodeOptions: [],
      reMmNFCCodeOptions: [],
    };
  },
  computed: {
    IsShowDatePicker() {
      let self = this;
      if (
        !self.reMmBarcode &&
        !self.reMmDepartmentMaterialCode
      ) {
        self.reMmTransactionDateStart = null;
        self.reMmTransactionDateEnd = null;

        $("#reMmTransactionDateStart")
          .val("")
          .trigger("change");

        $("#reMmTransactionDateEnd")
          .val("")
          .trigger("change");

        return true;
      }
      return false;

    },
  },
  methods: {
    formReset: function (e) {
      let self = this;
      self.reMmBarcode = null;
      self.reMmDepartmentMaterialCode = [];
      self.reMmNFCCode = [];
      self.reMmTransactionDateStart = null;
      self.reMmTransactionDateEnd = null;

      $("#reMmBarcode")
        .val("")
        .trigger("change");

      $("#reMmDepartmentMaterialCode")
        .val("")
        .trigger("change");

    },
    formSubmit: function (e) {
      let self = this;

      if (
        !self.reMmBarcode &&
        self.reMmDepartmentMaterialCode.length === 0 &&
        !self.reMmTransactionDateStart &&
        !self.reMmTransactionDateEnd
      ) {
        Swal.fire(
          'เกิดข้อผิดพลาด',
          'กรุณาระบุเงื่อนไขรายงานอย่างน้อย 1 เงื่อนไข:<br>' +
          '1. BARCODE<br>' +
          '2. รหัสทรัพย์สิน(เบียร์สด)<br>' +
          '3. วันที่(เริ่มต้น) - วันที่(สิ้นสุด)',
          'warning'
        );
        return false;
      }

      if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
        return false;
      } else if (
        self.reMmTransactionDateStart &&
        !self.reMmTransactionDateEnd
      ) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
        return false;
      }

      e.preventDefault();
      var table = $("#movementTable").DataTable();
      table.draw();
    },
    exportMovement: function (e) {
      e.preventDefault();
      let self = this;

      if (
        !self.reMmBarcode &&
        self.reMmDepartmentMaterialCode.length === 0 &&
        !self.reMmTransactionDateStart &&
        !self.reMmTransactionDateEnd
      ) {
        Swal.fire(
          'เกิดข้อผิดพลาด',
          'กรุณาระบุเงื่อนไขรายงานอย่างน้อย 1 เงื่อนไข:<br>' +
          '1. BARCODE<br>' +
          '2. รหัสทรัพย์สิน(เบียร์สด)<br>' +
          '3. วันที่(เริ่มต้น) - วันที่(สิ้นสุด)',
          'warning'
        );
        return false;
      }

      if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
        return false;
      } else if (
        self.reMmTransactionDateStart &&
        !self.reMmTransactionDateEnd
      ) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportMovement",
        responseType: "arraybuffer",
        data: {
          TransactionDateStart: self.reMmTransactionDateStart != null ? self.reMmTransactionDateStart.format("DD/MM/YYYY") : self.reMmTransactionDateStart,
          TransactionDateEnd: self.reMmTransactionDateEnd != null ? self.reMmTransactionDateEnd.format("DD/MM/YYYY") : self.reMmTransactionDateEnd,
          IsInitial: self.reMmIsInitial,
          Barcode: self.reMmBarcode,
          NFCCode: self.reMmNFCCode,
          DepartmentMaterialCode: self.reMmDepartmentMaterialCode,
          OrderByCollum: self.reOrderBy != null ? this.OrderName(self.reOrderBy[0][0]) : null,
          OrderBy: self.reOrderBy != null ? self.reOrderBy[0][1] : null
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function (error) {
          // Issue #59 (2026-06-10): responseType=arraybuffer → error.response.data
          //   เป็น ArrayBuffer (ไม่ใช่ JSON object) → ต้อง decode + parse ก่อน
          var msg = "เกิดข้อผิดพลาดขณะ Export";
          try {
            var raw = error && error.response && error.response.data;
            if (raw instanceof ArrayBuffer) {
              var text = new TextDecoder("utf-8").decode(new Uint8Array(raw));
              try {
                var parsed = JSON.parse(text);
                msg = parsed.Message || parsed.message || text || msg;
              } catch (e) {
                msg = text || msg;
              }
            } else if (raw && (raw.Message || raw.message)) {
              msg = raw.Message || raw.message;
            }
          } catch (e) { /* fallback to default msg */ }
          Swal.fire("เกิดข้อผิดพลาด", msg, "error");
        })
        .then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    OrderName: function (e) {
      if (e == 0) {
        var collumName = 'TransactionDate';
      }
      else if (e == 1) {
        var collumName = 'TransactionDate';
      }
      else if (e == 2) {
        var collumName = 'BarcodeNoOld';
      }
      else if (e == 3) {
        var collumName = 'DepartmentMaterialCode';
      }
      else if (e == 4) {
        var collumName = 'ProductTypeName';
      }
      else if (e == 5) {
        var collumName = 'MaterialCode';
      }
      else if (e == 6) {
        var collumName = 'ProductBrandName';
      }
      else if (e == 7) {
        var collumName = 'JobNumber';
      }
      else if (e == 8) {
        var collumName = 'JobTypeName';
      }
      else if (e == 9) {
        var collumName = 'BarcodeStatusName';
      }
      else if (e == 10) {
        var collumName = 'OriginName';
      }
      else if (e == 11) {
        var collumName = 'DestinationName';
      }
      else if (e == 12) {
        var collumName = 'TransitCompanyName';
      }
      else if (e == 13) {
        var collumName = 'TransitCarReg';
      }
      else {
        var collumName = 'TransactionDate';
      }

      return collumName;
    },
    LoadreMmDepartmentMaterialCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reMmDepartmentMaterialCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2DepartmentMaterial", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reMmDepartmentMaterialCodeOptions = [];
              data.forEach((element) => {
                self.reMmDepartmentMaterialCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reMmDepartmentMaterialCodeOptions);
          })
          .catch(function (error) { });
      }
    },
    LoadreMmNFCCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reMmNFCCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2NFC", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              data.forEach((element) => {
                self.reMmNFCCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reMmNFCCodeOptions);
          })
          .catch(function (error) { });
      }
    },
    ClearAfterselect: function () {
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reMmDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reMmTransactionDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reMmTransactionDateStart = moment().set("date",1);
    $(self.$refs.reMmTransactionDateStart)
      .datepicker(
        "update",
        !!self.reMmTransactionDateStart
          ? self.reMmTransactionDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function (e) {
        self.reMmTransactionDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reMmTransactionDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reMmTransactionDateEnd = moment().endOf('month');
    $(self.$refs.reMmTransactionDateEnd)
      .datepicker(
        "update",
        !!self.reMmTransactionDateEnd
          ? self.reMmTransactionDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function (e) {
        self.reMmTransactionDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });
      
    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#movementTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/Movement",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function (d) {
            let jsonSearch = {
              TransactionDateStart:
                self.reMmTransactionDateStart != null
                  ? self.reMmTransactionDateStart.format("DD/MM/YYYY")
                  : self.reMmTransactionDateStart,
              TransactionDateEnd:
                self.reMmTransactionDateEnd != null
                  ? self.reMmTransactionDateEnd.format("DD/MM/YYYY")
                  : self.reMmTransactionDateEnd,
              IsInitial: self.reMmIsInitial,
              Barcode: self.reMmBarcode,
              NFCCode: self.reMmNFCCode,
              DepartmentMaterialCode: self.reMmDepartmentMaterialCode,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: self.reOrderBy = [[1, "desc"]],
        columns: [
          {
            data: "transactionDate",
            className: "text-center",
            render: function (data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          {
            data: "transactionDate",
            className: "text-center",
            render: function (data, type, full, meta) {
              return full.transactionDateString;
            },
          },
          { data: "barcodeNoOld", className: "text-center" },
          { data: "departmentMaterialCode", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          {
            data: "materialCode",
            className: "text-center",
            render: function (data, type, full, meta) {
              return full.materialCode + " " + full.materialName;
            },
          },
          { data: "productBrandName", className: "text-center" },
          {
            data: "jobNumber",
            className: "text-center",
            render: function (data, type, full, meta) {
              return data + '<br><div class="actionsOpenJob"></div>';
            },
          },
          { data: "jobTypeName", className: "text-center" },
          { data: "barcodeStatusName", className: "text-center" },
          { data: "originName", className: "text-center" },
          { data: "destinationName", className: "text-center" },
          { data: "transitCompanyName", className: "text-center" },
          { data: "transitCarReg", className: "text-center" },
        ],
        drawCallback: function (settings) {
          self.reMmIsInitial = false;
          self.reMmDateReq = moment().format("DD/MM/YYYY h:mm a");
        },
      })
      .on("preXhr.dt", function () {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function () {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actionsOpenJob").each(function (i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new ActionsOpenJob({ data: { data }, parent: self }).$mount(el);
          }
        });
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// App/Components/Report/Movement.vue